import { render } from "./FrontLayout.vue?vue&type=template&id=b26b0708&scoped=true"
import script from "./FrontLayout.vue?vue&type=script&lang=js"
export * from "./FrontLayout.vue?vue&type=script&lang=js"

import "./FrontLayout.vue?vue&type=style&index=0&id=b26b0708&scoped=true&lang=less"
import "./FrontLayout.vue?vue&type=style&index=1&id=b26b0708&lang=css"

import exportComponent from "C:\\Users\\86183\\Desktop\\yw-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b26b0708"]])

export default __exports__